<template>
  <div id="navBar-custom" class="w-100 f-c-s">
    <b-navbar toggleable="lg">
      <b-navbar-brand href="https://vadaroom.ec.iau.ir/">
        <img
          class="ml-2 cp animate__animated animate__headShake animate__delay-1s"
          :key="animateTime"
          :src="require(`@/assets/images/home/vadaroom-logo-white.png`)"
      /></b-navbar-brand>

      <b-navbar-toggle v-b-toggle.sidebar-backdrop></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="https://vadaroom.ec.iau.ir/">صفحه اصلی</b-nav-item>
          <b-nav-item href="https://vadaroom.ec.iau.ir/contact"
            >تماس با ما</b-nav-item
          >
          <b-nav-item href="https://vadaroom.ec.iau.ir/support"
            >پشتیبانی</b-nav-item
          >
          <b-nav-item href="https://vadaroom.ec.iau.ir/guide"
            >راهنما</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div>
      <b-sidebar
        id="sidebar-backdrop"
        backdrop
        shadow
      >
        <div class="w-100 f-c-c">
          <img
            class="ml-2 cp animate__animated animate__headShake animate__delay-1s"
            style="width: 10rem; margin: 3rem 0"
            :key="animateTime"
            :src="require(`@/assets/images/home/vadaroom-logo-blue.png`)"
          />
        </div>
        <div class="px-3 py-2">
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item href="https://vadaroom.ec.iau.ir/"
                >صفحه اصلی</b-nav-item
              >
              <b-nav-item href="https://vadaroom.ec.iau.ir/contact"
                >تماس با ما</b-nav-item
              >
              <b-nav-item href="https://vadaroom.ec.iau.ir/support"
                >پشتیبانی</b-nav-item
              >
              <b-nav-item href="https://vadaroom.ec.iau.ir/guide"
                >راهنما</b-nav-item
              >
            </b-nav>
          </nav>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Login-Navbar",
  data() {
    return {
      animateTime: 0,
      isShow: 1,
      footer: true,
      isshowModal: false,
    };
  },
  computed: {
    ...mapState({
      isShowNavStatus: (state) => state.gap.isShowNavStatus,
    }),
  },
  methods: {
    ...mapActions("gap", ["isShowNavFunction", "exitFunction"]),
    hideModal() {
      document.querySelector(".login").classList.remove("blurBack");
      this.isshowModal = false;
    },
    mobileNavbar() {
      this.$refs["homeNavbar-modal"].show();
      this.isshowModal = true;
      document.querySelector(".login").classList.add("blurBack");
    },
    selectLoginNavbarFunc(i) {
      // this.isShow = i;
      // if (this.isshowModal) {
      //   this.$refs["homeNavbar-modal"].hide();
      //   document.getElementById("login").classList.remove("blurBack");
      //   this.isshowModal = false;
      // }
      // if (i == 1) {
      //   setTimeout(this.draw, 700);
      // }

      this.isShowNavFunction(i);
      if (this.isshowModal) {
        this.$refs["homeNavbar-modal"].hide();
        document.querySelector(".login").classList.remove("blurBack");
        this.isshowModal = false;
      }
      if (i == 1) {
        this.exitFunction();
        this.$router.push({ name: "home" });
      } else if (i == 2) {
        if (this.$router.currentRoute.name !== "contact") {
          this.$router.push({ name: "contact" });
        }
      } else if (i == 3) {
        if (this.$router.currentRoute.name !== "guide") {
          this.$router.push({ name: "guide" });
        }
      } else {
        if (this.$router.currentRoute.name !== "support") {
          this.$router.push({ name: "support" });
        }
      }
    },
  },
  mounted() {
    setInterval(() => {
      this.animateTime = this.animateTime + 1;
    }, 10000);
  },
};
</script>
<style lang="scss" scoped>
.navbar {
  position: absolute;
  top: 0;
  width: 100%;
  padding: 1rem;
  z-index: 999999;
  .navbar-collapse {
    .navbar-nav {
      img {
        width: 80px;
      }
      .nav-item {
        .nav-link {
          color: white;
          font-size: 100%;
          &:hover {
            color: #125488;
          }
        }
      }
      .active {
        .nav-link {
          color: #125488;
        }
      }
    }
  }
}
@media (max-width: 576px) {
  .navbar .navbar-collapse {
    background-color: unset;
    border-radius: unset;
  }
  .homeNavbar {
    display: none !important;
  }
}
</style>